var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("b-col", { attrs: { cols: "12" } }, [
            _c("img", {
              staticClass: "mr-2",
              attrs: {
                src: "/static-appopensalud/img/icons/cart-grey.svg",
                height: "30",
                width: "30"
              }
            }),
            _vm._v(" "),
            _c("h4", {
              staticClass: "summary-title",
              domProps: { innerHTML: _vm._s(_vm.$t("payments.buySummary")) }
            })
          ]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("b-col", { staticClass: "mt-3", attrs: { cols: "12", sm: "8" } }, [
            _c("label", {
              staticClass: "block",
              domProps: { innerHTML: _vm._s(_vm.$t("payments.product")) }
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "bold",
              domProps: { innerHTML: _vm._s(_vm.productDescription) }
            })
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "mt-3", attrs: { cols: "12", sm: "4" } }, [
            _c("label", {
              staticClass: "block",
              domProps: { innerHTML: _vm._s(_vm.$t("payments.price")) }
            }),
            _vm._v(" "),
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.price + " " + _vm.currency) }
            })
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-4" },
        [
          _c(
            "b-col",
            { staticClass: "align-center", attrs: { cols: "6" } },
            [
              _c("back-button", {
                attrs: {
                  withoutButton: "",
                  action: function() {
                    return _vm.$emit("back")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { staticClass: "align-right", attrs: { cols: "6" } },
            [
              _c("base-button", { on: { click: _vm.goPaymentStep } }, [
                _vm._v(_vm._s(_vm.$t("continue")))
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29029799", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29029799","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentSummary.vue
// module id = 3101
// module chunks = 46 47